import { Col, Image, Row, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { Typography, Button, ResponsiveContainer } from '@sunday/component';
import Layout from 'components/Layout';
import { config } from '../../config';
import style from './contact.module.scss';
import IceCreamMap from 'components/IceCreamMap/IceCreamMap';
import cn from 'classnames';
import { useState } from 'react';

const { ASSET_PREFIX } = config;
export const ContactUsPageNameSpace = ['page.contact'];

const Contact = () => {
  const { t, i18n } = useTranslation(ContactUsPageNameSpace);
  console.log(i18n.language);
  console.log(i18n.isInitialized);
  return (
    <Layout>
      <Row align='middle' gutter={24} className={style.heroBanner}>
        <Col xs={{ span: 24 }} sm={{ span: 6 }} lg={{ span: 6, offset: 1 }} style={{ textAlign: 'center' }}>
          <Image
            src={`${ASSET_PREFIX}/static/img/img-contact-banner.png`}
            preview={false}
            alt="hero-banner"
            className={style.banner}
          />
        </Col>
      </Row>

      <Row align='middle' className={style.location}>
        <ResponsiveContainer className={style.container}>
          <Typography.Display designLevel={3} weight='bold'>
            {t('location.title')}
          </Typography.Display>
          <Row>
            <Col xs={24} lg={12} className={style.column}>
              <Typography.Headline designLevel={2} weight='bold'>
                {t('location.companyName')}
              </Typography.Headline>
              <Typography.Title designLevel={3} className={style.secondary} style={{ marginBottom: '32px' }}>
                {t('location.address')}
              </Typography.Title>
              <div className={style.contactContainer}>
                <Image
                  src={`${ASSET_PREFIX}/static/icon/ic-phone-ci.svg`}
                  preview={false}
                  alt="hero-banner"
                  style={{ width: '24px', height: '24px' }}
                />
                <div className={style.column}>
                  <a href={`tel:${t('location.contact.phone.value')}`}>
                    <Typography.Title designLevel={3} weight='bold'>
                      {t('location.contact.phone.value')}
                    </Typography.Title>
                  </a>
                  <Typography.Title designLevel={3} className={style.secondary} >
                    {t('location.contact.phone.hour')}
                  </Typography.Title>
                </div>
              </div>
              <div className={style.contactContainer}>
                <Image
                  src={`${ASSET_PREFIX}/static/icon/ic-mail-ci.svg`}
                  preview={false}
                  alt="hero-banner"
                  style={{ width: '24px', height: '24px' }}
                />
                <div className={style.column}>
                  <a href={`mailto:${t('location.contact.email.value')}`}>
                    <Typography.Title designLevel={3} weight='bold'>
                      {t('location.contact.email.value')}
                    </Typography.Title>
                  </a>
                  <Typography.Title designLevel={3} className={style.secondary}>
                    {t('location.contact.email.hour')}
                  </Typography.Title>
                </div>
              </div>
            </Col>
            <Col xs={24} lg={12}>
              <IceCreamMap />
            </Col>
          </Row>
        </ResponsiveContainer>
      </Row>

      

    </Layout>
  );
};

export default Contact;
